import { timelineEvent } from "@/mocks/events";

const nodeStyle = (tone: string) => {
  switch (tone) {
    case "accent":
      return "bg-accent-500";
    case "secondary":
      return "bg-secondary-500";
    default:
      return "bg-primary-500";
  }
};

const nodeBadge = (tone: string) => {
  switch (tone) {
    case "accent":
      return "bg-accent-100 text-accent-800";
    case "secondary":
      return "bg-secondary-200 text-secondary-800";
    default:
      return "bg-primary-100 text-primary-800";
  }
};

export default function Timeline() {
  return (
    <section id="timeline" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-[0.85fr_1.15fr]">
          {/* left intro */}
          <div className="lg:sticky lg:top-28 lg:self-start">
            <p className="inline-flex items-center gap-2 text-sm font-bold text-accent-700">
              <span className="h-px w-6 bg-accent-500" />
              反转档案 · 深度追踪
            </p>
            <h2 className="mt-2 font-heading text-2xl font-black leading-tight text-foreground-950 md:text-4xl">
              一段瓜，<br />从发酵到落地的完整脉络
            </h2>
            <p className="mt-4 max-w-lg text-sm leading-relaxed text-foreground-600 md:text-base">
              我们为每一个<span className="font-bold text-foreground-900">持续更新</span>的重点事件建立时间线档案，
              用节点还原故事的每一步转向。透过时间线看全貌，那些反转再反转的瓜点，其实早有迹可循。
            </p>
            <div className="mt-6 overflow-hidden rounded-2xl border border-background-200 bg-background-50">
              <img
                src="https://readdy.ai/api/search-image?query=warm%20editorial%20documentary%20photo%20of%20a%20timeline%20chronicle%20of%20events%2C%20retro%20newspaper%20clippings%20and%20magnifying%20glass%20on%20wooden%20desk%2C%20amber%20and%20cream%20palette%2C%20soft%20cinematic%20light%2C%20high%20detail&width=700&height=420&seq=archive-hero&orientation=landscape"
                alt="事件反转档案时间线追踪背景配图"
                className="h-48 w-full object-cover md:h-56"
              />
            </div>
          </div>

          {/* right nodes */}
          <div className="relative">
            <div className="relative pl-6 md:pl-8">
              <span
                className="absolute left-[5px] top-2 h-full w-px bg-background-300 md:left-[7px]"
                aria-hidden="true"
              />
              <div className="flex flex-col gap-7">
                {timelineEvent.nodes.map((node, i) => (
                  <div key={i} className="relative">
                    <span
                      className={`absolute -left-6 top-1.5 h-3 w-3 rounded-full ring-4 ring-background-100 md:-left-8 ${nodeStyle(
                        node.tone
                      )}`}
                      aria-hidden="true"
                    />
                    <div className="rounded-xl border border-background-200 bg-background-50 p-5 md:p-6">
                      <div className="flex flex-wrap items-center gap-3">
                        <span className="font-label text-xs font-bold text-foreground-500">
                          {node.date}
                        </span>
                        <span
                          className={`whitespace-nowrap rounded-full px-2.5 py-0.5 text-[11px] font-bold ${nodeBadge(
                            node.tone
                          )}`}
                        >
                          {node.phase}
                        </span>
                      </div>
                      <h3 className="mt-2 font-heading text-lg font-black text-foreground-950">
                        {node.title}
                      </h3>
                      <p className="mt-2 text-sm leading-relaxed text-foreground-600">{node.text}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}